/**
 * VersionCell Component
 *
 * Renders normalized technology version using parseTechnologyVersion utility.
 * Already used by QueryBuilder but needs cell component for consistency.
 */

import React from 'react';

import { Technology } from '@/types';
import { parseTechnologyVersion } from '@/utils/entities/technology.util';

export interface VersionCellProps {
  entity: Technology;
}

/**
 * Displays beautified version string
 *
 * Uses parseTechnologyVersion() to:
 * - Combine version parts (version, update, edition, etc.)
 * - Filter out "any" placeholders
 * - Capitalize and clean formatting
 *
 * @example
 * ```typescript
 * // Raw: version="2.4.41", update="", edition="any"
 * // Displays: "2.4.41"
 *
 * // Raw: version="", update="", edition=""
 * // Displays: "unknown"
 * ```
 */
export const VersionCell: React.FC<VersionCellProps> = React.memo(
  ({ entity }) => {
    const displayVersion = parseTechnologyVersion(entity) || 'unknown';

    return <span className="text-chariot-text-primary">{displayVersion}</span>;
  }
);

VersionCell.displayName = 'VersionCell';
